import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'suggestionsTabLabel'
	| 'forYouTabLabel'
	| 'quickActionsTabLabel'
	| 'yourWorkTabLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		suggestionsTabLabel: {
			id: 'ai-mate.rovo-tabs.suggestions-tab-label',
			defaultMessage: 'Quick actions',
			description: 'Label for the Quick Actions tab in the mini-modal',
		},
		forYouTabLabel: {
			id: 'ai-mate.rovo-tabs.for-you-tab-label',
			defaultMessage: 'Your work',
			description: 'Label for the Your Work tab in the mini-modal',
		},
		quickActionsTabLabel: {
			id: 'ai-mate.rovo-tabs.quick-actions-tab-label',
			defaultMessage: 'Quick actions',
			description: 'Label for the Quick Actions tab in the mini-modal',
		},
		yourWorkTabLabel: {
			id: 'ai-mate.rovo-tabs.your-work-tab-label',
			defaultMessage: 'Your work',
			description: 'Label for the Your Work tab in the mini-modal',
		},
	});

export default message;
